
import mapboxgl from 'mapbox-gl';
import { City } from '../../../../data/types/city-types';
import { formatCurrencyShort } from '../../../../data/utils/money-utils';
import { getPresenceColor } from '../../../../utils/church-presence';

// Export the getPopupContent function to be used in city-marker-creation.ts
export const getPopupContent = (city: City): string => {
  return `
    <div class="p-3 bg-white/95 backdrop-blur-sm rounded-lg shadow-md">
      <div class="flex items-center justify-between">
        <h3 class="font-medium text-base">${city.name}</h3>
        <div class="px-2 py-0.5 rounded-full text-xs text-white presence-${city.church_presence.toLowerCase()}" 
             style="background-color: ${getPresenceColor(city.church_presence)}">
          ${city.church_presence}
        </div>
      </div>
      <div class="text-sm text-gray-600 mt-1 space-y-1">
        <div class="flex items-center">
          <span class="w-24">Funding:</span> 
          <span class="font-nasalization funding-amount">${formatCurrencyShort(city.funding_amount || 0)}</span>
        </div>
        <div class="flex items-center">
          <span class="w-24">Pledges:</span>
          <span class="font-nasalization funding-amount">${formatCurrencyShort(city.pledges || 0)}</span>
        </div>
        <div class="flex items-center">
          <span class="w-24">Churches:</span>
          <span class="font-medium">${city.churches_count || 0}</span>
        </div>
        <div class="flex items-center">
          <span class="w-24">Missionaries:</span>
          <span class="font-medium">${city.missionaries || 0}</span>
        </div>
        ${city.population ? `
        <div class="flex items-center">
          <span class="w-24">Population:</span>
          <span class="font-medium">${city.population.toLocaleString()}</span>
        </div>` : ''}
      </div>
      ${city.funding_percentage !== undefined ? `
      <div class="w-full bg-gray-200 rounded-full h-1.5 mt-2">
        <div class="bg-[#1EAEDB] h-1.5 rounded-full" style="width: ${city.funding_percentage}%"></div>
      </div>` : ''}
    </div>
  `;
};

export const createCityPopup = (city: City): mapboxgl.Popup => {
  return new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false,
    offset: [0, -10],
    className: 'city-popup',
    maxWidth: '300px'
  }).setHTML(getPopupContent(city));
};
